import { useCallback, useEffect, useState } from 'react'
import { Container, Row, Tab, Tabs } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import PackageCard from './PackageCard'
import { mediaQueryPoint, useMediaQuery } from 'utils/hooks'
import { useQuery } from 'react-query'
import { getPackageQuery } from 'dataLayer/game'
import { getUserinfo, saveUserInfo } from 'utils/localStorage'

function ShopPage() {
	const { t } = useTranslation()
	const isMobile = useMediaQuery(`(max-width: ${mediaQueryPoint.md}px)`)
	const user = getUserinfo()
	const { data: packages } = useQuery(getPackageQuery())
	const [reload, setReload] = useState(1)
	const subPackages = packages?.filter(item => item.packageType === 1)
	const retailPackages = packages?.filter(item => item.packageType === 2)

	const [key, setKey] = useState(1)
	useEffect(() => {
		console.log('reload page', reload)
	}, [user?.packageCurrent, user?.isRegisted])
	const handleLocalstorage = data => {
		if (data?.isRegisted !== undefined && !data?.packageCurrent) {
			saveUserInfo({
				...user,
				isRegisted: data?.isRegisted,
			})
			setReload(new Date() * 1 + 1)
		} else if (!data?.isRegisted && data?.packageCurrent) {
			saveUserInfo({
				...user,
				packageCurrent: data?.packageCurrent,
			})
			setReload(new Date() * 1 + 1)
		}
	}

	// TODO: Grab is not working
	// const packageRef = useRef(null)
	// let pos = { left: 0, x: 0 }
	// function mouseDownHandler(e) {
	// 	packageRef.current.style.cursor = 'grabbing'
	// 	packageRef.current.style.userSelect = 'none'

	// 	pos = {
	// 		// The current scroll
	// 		left: packageRef.current.scrollLeft,
	// 		// Get the current mouse position
	// 		x: e.clientX,
	// 	}

	// 	document.addEventListener('mousemove', mouseMoveHandler)
	// 	document.addEventListener('mouseup', mouseUpHandler)
	// }
	// function mouseUpHandler() {
	// 	document.removeEventListener('mousemove', mouseMoveHandler)
	// 	document.removeEventListener('mouseup', mouseUpHandler)

	// 	packageRef.current.style.cursor = 'grab'
	// 	packageRef.current.style.removeProperty('user-select')
	// }
	// function mouseMoveHandler(e) {
	// 	// How far the mouse has been moved
	// 	const dx = e.clientX - pos.x
	// 	// Scroll the element
	// 	packageRef.current.scrollLeft = pos.left - dx
	// }
	return (
		<>
			<Container fluid className="shoppage-container">
				<Row className="mt-4 mb-3">
					<p>{t('shoppage.choose')}</p>
					<h1>{t('shoppage.title')}</h1>
				</Row>
				<div className={`package-container ${isMobile ? 'mobile' : ''}`}>
					<Tabs
						id="controlled-tab-example"
						activeKey={key}
						onSelect={k => setKey(k)}
						className="mb-4 mt-4 mt-md-0"
					>
						<Tab eventKey={1} title={t('shoppage.sub')}>
							<PackageCard
								data={subPackages}
								isSubscription={true}
								tabValue={1}
								isRegisted={user?.isRegisted || 0}
								handleLocalstorage={handleLocalstorage}
							/>
						</Tab>
						<Tab eventKey={2} title={t('shoppage.retail')}>
							<PackageCard
								data={retailPackages}
								tabValue={2}
							// packageCurrent={user?.packageCurrent || 'null'}
							// handleLocalstorage={handleLocalstorage}
							/>
						</Tab>
					</Tabs>
				</div>
			</Container>
		</>
	)
}

export default ShopPage
